module.exports = __webpack_public_path__ + "img/img1.eec85df2.jpeg";